import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IAIRepository } from '@/api/fe-api/domain/repositories/ai-respository';

import { GetChatHistory } from '../../queries/ai/get-chat-history';

export namespace SendMessage {
  export type Input = IAIRepository.SendMessageInput;
  export type Output = IAIRepository.SendMessageOutput;

  export function useMutation() {
    const { repositories } = useDependencies();
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn: (input) => repositories.ai.sendMessage(input),
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: GetChatHistory.key(),
        });
      },
    });
  }
}
